var _style, _rect, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZarafiyat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "katman_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 155.9 311.8",
    style: {
      enableBackground: "new 0 0 155.9 311.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#636569;}\r\n.st1 {\r\n  fill: #FFFFFF; /* Beyaz dolgu rengi */\r\n  stroke: none; /* \xC7er\xE7eve \xE7izgisi yok */\r\n}.st2 {\r\n  fill: #000; /* K\u0131rm\u0131z\u0131 renk */\r\n  fill-rule: evenodd;\r\n  clip-rule: evenodd;\r\n}\t.st3{fill:#13110C;}\r\n\t.st4{fill:none;stroke:#13110C;stroke-width:0.48;stroke-linecap:square;stroke-miterlimit:10;}\r\n\t.st5{fill:none;stroke:#E30D13;stroke-width:0.72;stroke-linecap:round;stroke-miterlimit:10;}\r\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 65.2,
    y: 2.8,
    className: "st0",
    width: 25.5,
    height: 25.5
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 15.6,
    y1: 72.2,
    x2: 140.3,
    y2: 72.2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 140.3,
    y1: 72.2,
    x2: 140.3,
    y2: 111.8
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 140.3,
    y1: 111.8,
    x2: 15.6,
    y2: 111.8
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 15.6,
    y1: 111.8,
    x2: 15.6,
    y2: 72.2
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 15.6,
    y1: 72.2,
    x2: 140.3,
    y2: 72.2
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 140.3,
    y1: 72.2,
    x2: 140.3,
    y2: 81.1
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 140.3,
    y1: 81.1,
    x2: 15.6,
    y2: 81.1
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 15.6,
    y1: 81.1,
    x2: 15.6,
    y2: 72.2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 77.9,
    cy: 15.6,
    r: 4.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZarafiyat);
export default __webpack_public_path__ + "static/media/zarafiyat.0842e5ca1828595a7b0453784886d104.svg";
export { ForwardRef as ReactComponent };